export const norwegian = {
  lang: 'nb',
  data: {
    titles: {
      course: 'Kurs',
      about_course: 'Om dette kurset',
      target_group: 'Målgruppe',
      course_content: 'Kursinnhold',
      course_images: 'Bilder',
      practical_information: 'Praktisk informasjon',
      curriculum: 'Læringsplan',
      place: 'Sted',
      meetup_place: 'Møtested',
      select_start_date: 'Velg dato',
      select_start_date_first: 'Velg dato først',
      selected_timeslot: 'Velg tid',
      payment: 'Deltagere',
      date: 'Dato',
      participants_number: 'Antall deltagere',
      customer_info: 'Kundeopplysninger',
      participant: 'Deltager',
      select_date_time: 'Velg dato og klokkeslett'
    },
    reviews: 'Tilbakemeldinger',
    read_more_reviews: 'Les flere tilbakemeldinger',
    no_available_seats: 'Ingen ledige plasser',
    sold_out: 'Utsolgt',
    free_seat: 'ledig plass',
    free_seats: 'ledige plasser',
    more_free_seats: 'eller flere ledige plasser',
    signup_deadline_passed: 'Påmeldingsfrist utløpt',
    time_zone_info: 'Klokkeslettene vises i lokal tid, vær obs dersom du er i en annen tidssone.',
    rs_member: 'RS-medlem',
    rs_non_member: 'Pris',
    become_rs_member: 'Bli RS-medlem',
    course_days: 'Antall kursdager',
    day: 'dag',
    days: 'dager',
    check_multi_participant: "Kjøper du kurs for {{ count }} andre?",
    select_participant: "Velg antall deltakere",
    self_participant: 'Skal du melde deg selv på kurset?',
    participant_form: {
      labels: {
        name: 'NAVN',
        email: 'E-POST',
        phone: 'TELEFONNUMMER',
        dateOfBirth: 'Fødselsdato',
        address: 'Adresse',
        guardianName: 'Foresattes navn'
      },
      placeholders: {
        name: 'Skriv inn navn til den som skal få kurset',
        email: 'Skriv inn e-post til den som skal få kurset',
        phone: 'Skriv inn telefonnummer til den som skal få kurset',
        dateOfBirth: 'Skriv inn fødselsdatoen til personen som skal motta kurset',
        address: 'Skriv inn adressen til personen som skal motta kurset',
        guardianName: 'Skriv inn vergenavnet på personen som skal motta kurset'
      },
      validations: {
        name: {
          required: 'Navn på deltaker er påkrevd.'
        },
        email: {
          required: 'E-post til deltakeren er påkrevd.',
          email: 'Det kan se ut som dette er en feilstavet e-postadresse, dobbeltsjekk gjerne at den er korrekt før du går videre.',
        },
        phone: {
          required: 'Telefonnummeret til deltakeren er påkrevd.',
          pattern: 'Vennligst oppgi telefonnummer med tall.',
          length: 'Oppgitt telefonnummer er ikke gyldig.'
        },
        dateOfBirth: {
          required: 'Deltakerens fødselsdato er påkrevd'
        },
        address: {
          required: 'Adresse til deltakeren er påkrevd'
        },
        guardianName: {
          required: 'Foresatte Navn på deltaker er påkrevd'
        }
      },
      participant_phone_help_message: 'Vi ser etter eksisterende RS Sjøliv-brukere på telefonnummer. Hvis ingenting dukker opp, skriv også inn navn og e-post.',
      participant_email_help_message: 'Husk at e-postadressen må være den samme som man (du eller den du kjøper kurs for) logger inn/registrerer seg med for å få tilgang til kurset.',
      submit_form: 'FULLFØR BETALING'
    },
    action_buttons: {
      back: 'Tilbake',
      buy: 'Kjøp',
      see_more_dates: 'Se mer',
      login_required: 'Innlogging kreves'
    }
  },
};
